<shell-leal-spinner *ngIf="spinnerActive"/>
